import { PATH } from '../path';
import { useAppSelector } from '@/app/store';
import { isTelegramWebApp } from '@/shared/lib';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ChainProvider: FC<PropsWithChildren> = ({ children }) => {
  const nav = useNavigate();
  const isTgApp = isTelegramWebApp();
  const { chainId } = useAppSelector((state) => state.initial);

  useEffect(() => {
    if (!chainId && isTgApp && import.meta.env.DEV) nav(PATH.developer);
  }, [chainId, nav, isTgApp]);

  return <>{children}</>;
};
